import React, { useState } from "react";
import { Link, TextField, Tooltip } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import "../Supporting.scss";

interface Props {
  title: string;
  value: any;
  attrName: any;
  value_update: Function;
  warn_status: boolean;
  info_status?: boolean;
  info_message?: string;
  class_name: string;
  error_messg?: string;
  password_status?: boolean;
  type?: string;
  disable?: boolean;
}

const defaultProps: Props = {
  title: "",
  value: "",
  attrName: "",
  value_update: () => {},
  warn_status: false,
  info_status: false,
  class_name: "inputField",
  error_messg: "Please enter valid value",
  info_message:
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor.",
  password_status: false,
  disable: false,
};

const RKTextField: React.FC<Props> = ({
  title,
  value,
  value_update,
  attrName,
  warn_status,
  class_name,
  error_messg,
  info_status,
  info_message,
  type,
  password_status,
}) => {
  const [passwordType, setPasswordType] = useState(type);
  const togglePassword = () => {
    if (passwordType === "password") {
      setPasswordType("text");
      return;
    }
    setPasswordType("password");
  };

  return (
    <div className={class_name}>
      <TextField
        fullWidth
        label={title}
        variant="outlined"
        type={passwordType}
        value={value}
        // disabled={true}
        onChange={(e) => {
          value_update(attrName, e.target.value);
        }}
      />
      {password_status == true ? (
        <Link onClick={togglePassword} className="passwordView">
          {passwordType === "password" ? (
            <VisibilityOffIcon />
          ) : (
            <VisibilityIcon />
          )}
        </Link>
      ) : null}

      {info_status === true ? (
        <Tooltip title={info_message === undefined ? "" : info_message}>
          <span className="infoMessage">
            <InfoOutlinedIcon />
          </span>
        </Tooltip>
      ) : null}
      {warn_status == true ? (
        <span className="error">{error_messg}</span>
      ) : null}
    </div>
  );
};

RKTextField.defaultProps = defaultProps;
export default RKTextField;
